import { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";

interface AIButtonProps {
  fieldValue: string;
  onChange: (value: string) => void;
  fieldType: string;
  currentFormData?: any;
}

const AIButton: React.FC<AIButtonProps> = ({ fieldValue, onChange, fieldType, currentFormData }) => {
  const [loading, setLoading] = useState(false);

  const handleGenerate = async () => {
    setLoading(true);
    axios.post("https://neuron.salesbotics.io/api/v1/ai/generate", {
      text: fieldValue,
      type: fieldType,
      current_form_data: currentFormData ? currentFormData : {},
    }).then(response => {
      onChange(response.data.text);
    }).catch(error => {
      toast.error("AI Content Generation is not available in your plan. Please upgrade to use this feature.");
    }).finally(() => {
      setLoading(false);
    });
  };

  return (
    <a 
      title="Generate AI Content"
      onClick={handleGenerate} 
      className="ml-2 p-1 text-[#0CAF60] hover:text-[#0CAF60] cursor-pointer"
    >
      {loading ? <p className="animate-spin">Writing...</p> : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          className="w-6 h-6"
        >
          {/* Magic wand - representing AI assistance */}
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M15 4l1 1m0 0l2 2M15 4l-2 2m3 3l1 1m0 0l2 2m-3-3l-2 2"
          />
          {/* Document with text lines */}
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M9 12h6m-6 3h4m2-9H8.2c-1.12 0-1.68 0-2.108.218a2 2 0 00-.874.874C5 7.52 5 8.08 5 9.2v8.6c0 1.12 0 1.68.218 2.108a2 2 0 00.874.874C6.52 21 7.08 21 8.2 21h7.6c1.12 0 1.68 0 2.108-.218a2 2 0 00.874-.874C19 19.48 19 18.92 19 17.8V9.2c0-1.12 0-1.68-.218-2.108a2 2 0 00-.874-.874C17.48 6 16.92 6 15.8 6H10"
          />
          {/* Sparkle effect */}
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M17 10.2l.5-.5m.5-2.5l.5.5"
          />
        </svg>
      )}
    </a>
  );
};

export default AIButton;